import * as React from 'react';


export default class Reorder extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">       
        <g id="Icons-/-16-x-16-/-CardView-/-Active" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="thumbView">
              <g id="Blue-highlights" transform="translate(9.000000, 1.000000)" stroke="none" fill="#43ADF1" fillRule="nonzero">
                  <polygon id="Path-2-Copy" points="4.26767488 4.52404255 4.26767488 0.683216482 5.51772897 0.683216482 5.51772897 5.52404255 0.758739351 5.52404255 0.758739351 4.52404255" id="selected"></polygon>
                  <polygon id="Path-2-Copy-2" points="4.26767488 12.5240425 4.26767488 8.68321648 5.51772897 8.68321648 5.51772897 13.5240425 0.758739351 13.5240425 0.758739351 12.5240425" id="selected"></polygon>
              </g>
              <g id="Black-box" transform="translate(1.000000, 1.000000)">
                  <rect id="Rectangle-4" x="0.5" y="0.5" width="5.22222222" height="5.22222222" rx="1"></rect>
                  <rect id="Rectangle-4-Copy-2" x="0.5" y="8.27777778" width="5.22222222" height="5.22222222" rx="1"></rect>
                  <rect id="Rectangle-4-Copy" x="8.27777778" y="0.5" width="5.22222222" height="5.22222222" rx="1"></rect>
                  <rect id="Rectangle-4-Copy-3" x="8.27777778" y="8.27777778" width="5.22222222" height="5.22222222" rx="1"></rect>
              </g>
            </g>
        </g>
      </svg>
    )
  }
}
